import { createModel } from "hox";
import { useState, useEffect } from "react";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/ScmTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { approvalService } from "./ApprovalService";
import { cloneDeep } from 'lodash';
import { UserFields, ApprovalShopFields, ApprovalFlowNodeFields, ApprovalFlowFields } from "./ApprovalTypes"
import { transPgToPagination } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import { orgService } from "@/views/organization/org/orgService";

export const useApprovalModel = createModel(function () {
  const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
  const { shopAndOrg: { shopType, shopCode }, allShopDs } = useGlobalModel();
  const [addApplyDrawer, setAddApplyDrawer] = useState<boolean>(false);
  const [addNodeDrawer, setAddNodeDrawer] = useState<{ visible: boolean, node?: ApprovalFlowNodeFields }>({ visible: false });
  //列表数据源
  const [dataSource, setDataSource] = useState<UserFields[]>([]);
  //列表数据源
  const [orgDataSource, setOrgDataSource] = useState<UserFields[]>([]);
  //列表数据源分页参数
  const [orgPgCfg, setOrgPgCfg] = useState<TablePaginationConfig>();
  //列表数据源分页参数
  const [pgCfg, setPgCfg] = useState<TablePaginationConfig>();
  const [selectedShop, setSelectedShop] = useState<any>();
  const [selectType, setSelectType] = useState<any>('');
  //流程节点
  const [flowNodes, setFlowNodes] = useState<ApprovalFlowNodeFields[]>([]);
  //选择的申请机构
  const [applys, setApplys] = useState<UserFields[]>();
  //更新页选择的节点
  const [selectFlow, setSelectFlow] = useState<{ flowId: string, nodeIndex?: number }>();
  //更新页流程列表
  const [approvalFlows, setApprovalFlows] = useState<ApprovalFlowFields[]>([]);

  useEffect(() => {
    setAddApplyDrawer(false);
    setFlowNodes([]);
    setApplys([]);
    setSelectFlow(undefined);
    setApprovalFlows([]);
    setSelectType('')
    if (selectedShop) {
      getShopFlow(selectedShop.key)
    }
  }, [selectedShop])

  const loadUserData = async (page: ISearchPage = initPgCfg, searchValue: any = {}) => {
    const searchParams = {
      ...searchValue,
      sourceApp: "portal",
      page: {
        pageSize: page?.pageSize ?? pgCfg?.pageSize ?? DEFAULT_PAGE_SIZE,
        pageNum: (page?.current || page?.pageNum) ?? pgCfg?.current ?? DEFAULT_FIRST_PAGE_NUM,
      }
    }
    let { retData } = await approvalService.getUser(searchParams);
    const { records, ...pg } = retData;
    setPgCfg(transPgToPagination(pg));
    setDataSource(records);
  }
  const loadOrgData = async (page: ISearchPage = initPgCfg, searchValue: any = {}) => {
    const searchParams = {
      ...searchValue,
      sourceApp: "portal",
      page: {
        pageSize: 100,
        pageNum: 1
      }
    }
    let { retData } = await orgService.page(searchParams);
    const { records, ...pg } = retData;
    setOrgPgCfg(transPgToPagination(pg));
    let newData = records.filter(item => item.pcode == 'jg' && item.code !== 'bjgf')
    setOrgDataSource(newData);
  }
  const getShopFlow = async (approvalType: any) => {
    await approvalService.getShopFlow(approvalType, shopCode).then(res => {
      const approvalFlow = res.retData;
      setSelectType(approvalFlow.length > 0 ? 'edit' : 'add')
      setApprovalFlows(approvalFlow ?? []);
    })
  }

  const guid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  const clone = (data: any) => {
    return cloneDeep<any>(JSON.parse(JSON.stringify(data)));
  }


  return {
    initPgCfg, dataSource, loadUserData, guid, clone,
    pgCfg, setPgCfg, orgPgCfg, setOrgPgCfg,
    orgDataSource, setOrgDataSource,
    addApplyDrawer, setAddApplyDrawer,
    addNodeDrawer, setAddNodeDrawer,
    selectedShop, setSelectedShop,
    flowNodes, setFlowNodes,
    selectFlow, setSelectFlow,
    applys, setApplys, loadOrgData,
    approvalFlows, setApprovalFlows, getShopFlow,
    selectType, setSelectType,
  }

});